module.exports = __webpack_public_path__ + "static/media/my-membership.fbd45038.svg";